import { t } from './data.js';

export function relTime(iso) {
  const d = new Date(iso);
  const diff = (new Date() - d) / 1000;
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)} ${t('common.minutes_ago')}`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}${t('common.hours_ago').trim()}`;
  if (diff < 86400 * 2) return t('common.yesterday');
  if (diff < 86400 * 30) return `${Math.floor(diff / 86400)}${t('common.days_ago').trim()}`;
  return d.toLocaleDateString('en-CA');
}

// Exact date and time, e.g. "12 Oct 2026, 09:13" — the hover title for a relTime() label.
export function dateTimeFull(iso) {
  if (!iso) return undefined;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return undefined;
  return d.toLocaleString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export function dateLong(iso) {
  return new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function dateShort(iso) {
  return new Date(iso).toLocaleDateString('en-CA');
}

export function timeShort(iso) {
  return new Date(iso).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
}

const IMAGE_EXTS = /\.(jpe?g|png|gif|webp|svg)$/i;
const PDF_EXT = /\.pdf$/i;
const VIDEO_EXTS = /\.(mp4)$/i;
const AUDIO_EXTS = /\.(mp3)$/i;
export const isImage = (name) => IMAGE_EXTS.test(name ?? '');
export const isPdf = (name) => PDF_EXT.test(name ?? '');
export const isVideo = (name) => VIDEO_EXTS.test(name ?? '');
export const isAudio = (name) => AUDIO_EXTS.test(name ?? '');

// Some components only get a `role` prop, others also get the full `me` object —
// checking both wherever available is the safe form, so centralize it rather than
// letting call sites drift between "me?.role === 'agent' || role === 'agent'" and
// a bare "role === 'agent'".
export const isAgentRole = (role, me) => me?.role === 'agent' || role === 'agent';

// docNumber is a free-form, optional field (a reference to an unrelated ERP
// document), not a guaranteed identifier - falls back to the real id whenever
// it's missing, which is common (drafts, non-document-related request types).
export const requestUrlKey = (request) => request?.docNumber || request?.id;

// crypto.randomUUID() only exists in secure contexts (HTTPS or localhost) - a
// plain-HTTP deployment on a network host (common for internal test servers)
// throws instead, so this falls back to a non-cryptographic v4-shaped UUID
// there. Fine for client-generated IDs (toast keys, idempotency keys) that
// only need to be unique, not unguessable.
export function genUUID() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
